/**
 * BaseParser - Interfaz base para parsers de herramientas LLM
 *
 * Todos los parsers deben extender esta clase e implementar los métodos requeridos.
 */
class BaseParser {
  constructor(name, priority = 0) {
    this.name = name;
    this.priority = priority; // Mayor número = mayor prioridad
  }

  /**
   * Obtiene los patrones regex que este parser puede manejar
   * @returns {Array<RegExp>} Array de patrones regex
   */
  getPatterns() {
    throw new Error(`${this.name} parser must implement getPatterns()`);
  }

  /**
   * Procesa el contenido y extrae matches
   * @param {string} content - Contenido a procesar
   * @returns {Array<Object>} Array de matches encontrados
   */
  extractMatches() {
    throw new Error(`${this.name} parser must implement extractMatches()`);
  }

  /**
   * Convierte el contenido a formato estándar (opcional)
   * @param {string} content - Contenido original
   * @returns {string} Contenido convertido
   */
  convertContent(content) {
    return content; // Por defecto, no convierte nada
  }

  /**
   * Crea el objeto part para renderizado
   * @param {Object} match - Match encontrado
   * @returns {Object} Part object
   */
  createPart() {
    throw new Error(`${this.name} parser must implement createPart()`);
  }
}

export default BaseParser;
